export const FIELDSET_TAG_NAME = "fieldset" as const;

export const FIELDSET_VARIANTS = ["plain", "card", "section", "list"] as const;

export const FIELDSET_GAPS = ["none", "sm", "md", "lg"] as const;

export const FIELDSET_WIDTHS = ["fill", "auto", "content"] as const;

export const FIELDSET_LEGEND_ALIGNS = ["left", "center", "right"] as const;
